import defaultPage from "@/mixins/pages/default.mixin";
import SingleLayout from "@/layouts/Single";

export default (strategy, options) => {
  return {
    mixins: [defaultPage(strategy, options)],
    components: {
      SingleLayout
    }
  };
};
